module.exports = __webpack_public_path__ + "img/full_logo_grey.ddaeb1fd.png";